import { age, INormData, INormWeight } from './interfaces/INormData'

export const ans: INormData = {
  [age.three]: {
    mean: 0.6414670659,
    std: 0.1560244115
  },
  [age.four]: {
    mean: 0.6638289037,
    std: 0.1462673399
  },
  [age.five]: {
    mean: 0.7095238095,
    std: 0.1642122187
  },
  [age.six]: {
    mean: 0.7435515873,
    std: 0.1400165807
  },
  [age.seven]: {
    mean: 0.7926682692,
    std: 0.1371688337
  }
}

export const symbolic: INormData = {
  [age.three]: {
    mean: 0.81875,
    std: 0.2362711758
  },
  [age.four]: {
    mean: 0.8666958042,
    std: 0.1651612982
  },
  [age.five]: {
    mean: 0.9165609137,
    std: 0.1241595467
  },
  [age.six]: {
    mean: 0.9211956522,
    std: 0.116646186
  },
  [age.seven]: {
    mean: 0.9511904762,
    std: 0.08214596268
  }
}

export const subtizing: INormData = {
  [age.three]: {
    mean: 0.7285714273,
    std: 0.1933311358
  },
  [age.four]: {
    mean: 0.7398373989,
    std: 0.1704851059
  },
  [age.five]: {
    mean: 0.8059829061,
    std: 0.1529649792
  },
  [age.six]: {
    mean: 0.8318840581,
    std: 0.147415477
  },
  [age.seven]: {
    mean: 0.8993399362,
    std: 0.1198432291
  }
}

export const sart: INormData = {
  [age.three]: {
    mean: 0.6859038099,
    std: 0.148413329
  },
  [age.four]: {
    mean: 0.7395445114,
    std: 0.1512297377
  },
  [age.five]: {
    mean: 0.8082508277,
    std: 0.1322894858
  },
  [age.six]: {
    mean: 0.8872901716,
    std: 0.115649128
  },
  [age.seven]: {
    mean: 0.9140350908,
    std: 0.1058358208
  }
}

export const sartRev: INormData = {
  [age.three]: {
    mean: 0.8157790949,
    std: 0.1808154764
  },
  [age.four]: {
    mean: 0.8453143583,
    std: 0.1716833141
  },
  [age.five]: {
    mean: 0.8793162447,
    std: 0.1460557449
  },
  [age.six]: {
    mean: 0.9240310123,
    std: 0.1274339309
  },
  [age.seven]: {
    mean: 0.9303030334,
    std: 0.1253260188
  }
}

export const cardSort: INormData = {
  [age.three]: {
    mean: 0.8561851687,
    std: 0.2390975052
  },
  [age.four]: {
    mean: 0.8883249805,
    std: 0.2126164306
  },
  [age.five]: {
    mean: 0.9153813688,
    std: 0.1842963992
  },
  [age.six]: {
    mean: 0.9125809188,
    std: 0.183013608
  },
  [age.seven]: {
    mean: 0.9143247284,
    std: 0.1593556017
  }
}

export const mentalRotation: INormData = {
  [age.three]: {
    mean: 0.6907649254,
    std: 0.162500676
  },
  [age.four]: {
    mean: 0.7414351852,
    std: 0.1774385657
  },
  [age.five]: {
    mean: 0.8003205128,
    std: 0.163627731
  },
  [age.six]: {
    mean: 0.8611680328,
    std: 0.1617158486
  },
  [age.seven]: {
    mean: 0.8983585859,
    std: 0.1211004391
  }
}

export const corsi: INormData = {
  [age.three]: {
    mean: 0.709242033,
    std: 0.2774737932
  },
  [age.four]: {
    mean: 0.7046519294,
    std: 0.2645212606
  },
  [age.five]: {
    mean: 0.7069966718,
    std: 0.1965971239
  },
  [age.six]: {
    mean: 0.7043689222,
    std: 0.1879881087
  },
  [age.seven]: {
    mean: 0.7074791245,
    std: 0.1648189297
  }
}

export const corsiRev: INormData = {
  [age.three]: {
    mean: 0.6551434802,
    std: 0.2851124045
  },
  [age.four]: {
    mean: 0.6406316845,
    std: 0.26324676
  },
  [age.five]: {
    mean: 0.6222636709,
    std: 0.2661419147
  },
  [age.six]: {
    mean: 0.6347140766,
    std: 0.2408403842
  },
  [age.seven]: {
    mean: 0.6801479596,
    std: 0.2194111224
  }
}

export enum stainScale {
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9
}

export enum NormRange {
  Low = 11,
  LowAverage = 23,
  Average = 77,
  HighAverage = 89,
  High = 100
}
export interface IData {
  percentail: number
  low: number
  high: number
  lowScoreRange: number | undefined
  highScoreRange: number | undefined
  range: NormRange
}
export interface INormativeInfo {
  [stainScale.one]: IData
  [stainScale.two]: IData
  [stainScale.three]: IData
  [stainScale.four]: IData
  [stainScale.five]: IData
  [stainScale.six]: IData
  [stainScale.seven]: IData
  [stainScale.eight]: IData
  [stainScale.nine]: IData
}
export const normativeInfo: INormativeInfo = {
  [stainScale.one]: {
    percentail: 4,
    low: 0,
    high: 4,
    lowScoreRange: undefined,
    highScoreRange: -1.75,
    range: NormRange.Low
  },
  [stainScale.two]: {
    percentail: 7,
    low: 4,
    high: 11,
    lowScoreRange: -1.75,
    highScoreRange: -1.25,
    range: NormRange.Low
  },
  [stainScale.three]: {
    percentail: 12,
    low: 11,
    high: 23,
    lowScoreRange: -1.25,
    highScoreRange: -0.75,
    range: NormRange.LowAverage
  },
  [stainScale.four]: {
    percentail: 17,
    low: 23,
    high: 40,
    lowScoreRange: -0.75,
    highScoreRange: -0.25,
    range: NormRange.Average
  },
  [stainScale.five]: {
    percentail: 20,
    low: 40,
    high: 60,
    lowScoreRange: -0.25,
    highScoreRange: 0.25,
    range: NormRange.Average
  },
  [stainScale.six]: {
    percentail: 17,
    low: 60,
    high: 77,
    lowScoreRange: 0.25,
    highScoreRange: 0.75,
    range: NormRange.Average
  },
  [stainScale.seven]: {
    percentail: 12,
    low: 77,
    high: 89,
    lowScoreRange: 0.75,
    highScoreRange: 1.25,
    range: NormRange.HighAverage
  },
  [stainScale.eight]: {
    percentail: 7,
    low: 89,
    high: 96,
    lowScoreRange: 1.25,
    highScoreRange: 1.75,
    range: NormRange.High
  },
  [stainScale.nine]: {
    percentail: 4,
    low: 96,
    high: 100,
    lowScoreRange: 1.75,
    highScoreRange: undefined,
    range: NormRange.High
  }
}
export const symbolicWeight: INormWeight = {
  [age.three]: 0.5,
  [age.five]: 0.35,
  [age.six]: 0.2,
  [age.seven]: 0.1,
  [age.eight]: 0.1
}
export const nonSymbolicWeight: INormWeight = {
  [age.three]: 0.3,
  [age.five]: 0.45,
  [age.six]: 0.65,
  [age.seven]: 0.8,
  [age.eight]: 0.8
}
export const enumerationWeight: INormWeight = {
  [age.three]: 0.2,
  [age.five]: 0.2,
  [age.six]: 0.15,
  [age.seven]: 0.1,
  [age.eight]: 0.1
}

export const inhibitionWeight: INormWeight = {
  [age.three]: 1.0 / 3.0,
  [age.five]: 0.3,
  [age.six]: 0.25,
  [age.seven]: 0.2,
  [age.eight]: 0.1
}
export const planningWeight: INormWeight = {
  [age.three]: 1.0 / 3.0,
  [age.five]: 0.32,
  [age.six]: 0.3,
  [age.seven]: 0.25,
  [age.eight]: 0.2
}
export const shiftingWeight: INormWeight = {
  [age.three]: 0,
  [age.five]: 0,
  [age.six]: 0,
  [age.seven]: 0,
  [age.eight]: 0
}
export const workingMemoryWeight: INormWeight = {
  [age.three]: 1.0 / 3.0,
  [age.five]: 0.38,
  [age.six]: 0.45,
  [age.seven]: 0.55,
  [age.eight]: 0.7
}

export const attentionInhibitionWeight: INormWeight = {
  [age.three]: 0.2,
  [age.five]: 0.2,
  [age.six]: 0.2,
  [age.seven]: 0.2,
  [age.eight]: 0.2
}

export const sustainAttentionWeight: INormWeight = {
  [age.three]: 0.4,
  [age.five]: 0.4,
  [age.six]: 0.4,
  [age.seven]: 0.4,
  [age.eight]: 0.4
}

export const hyperactiveWeight: INormWeight = {
  [age.three]: 0.4,
  [age.five]: 0.4,
  [age.six]: 0.4,
  [age.seven]: 0.4,
  [age.eight]: 0.4
}



// WEBPACK FOOTER //
// ./src/data/abitilies/normativeInfo.ts